/**
 * Countdown-Format für Share-Link-Ablauf: Granularität Tag → Stunde → Minute.
 *   diff > 24h: „läuft in X Tagen ab" · diff > 1h: „läuft in X Std ab"
 *   diff > 0:   „läuft in X min ab"   · diff ≤ 0: „abgelaufen" (defensiv —
 *   Backend filtert `expires_at > now()`).
 *
 * Aus `ExpiringShareRow.tsx` extrahiert (react-refresh/only-export-components:
 * Component-Files sollen nur Components exportieren) — separat testbar.
 */
export function formatExpiryCountdown(iso: string, now = Date.now()): string {
  const diffMs = new Date(iso).getTime() - now;
  if (diffMs <= 0) return 'abgelaufen';
  const min = Math.floor(diffMs / 60_000);
  if (min < 60) {
    return `läuft in ${min} min ab`;
  }
  const h = Math.floor(min / 60);
  if (h < 24) {
    return `läuft in ${h} Std ab`;
  }
  const d = Math.floor(h / 24);
  return `läuft in ${d} ${d === 1 ? 'Tag' : 'Tagen'} ab`;
}
